export default {
  title: "Contrôle d'accès : {{role}}",
  form: {
    companies: {
      label: 'Visible pour tous les membres ayant le rôle {{role}}',
      tooltip: "Cela sera ajouté aux emplacements auxquels le membre de l'équipe s'est inscrit",
    },
  },
  buttons: {
    save: 'Enregistrer',
  },
  toasts: {
    failed_to_load_data: 'Échec du chargement des données, veuillez actualiser la page',
    failed_to_save_changes: "Échec de l'enregistrement des modifications",
    changes_got_saved: 'Modifications enregistrées',
  },
};
